import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-gradient-to-b from-[#0A192F] to-[#112240]" data-id="element-70">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-71" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-12 gap-16 items-center relative z-10" data-id="element-72">
        {/* Left Content */}
        <motion.div className="lg:col-span-7 flex flex-col items-start text-left" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-73">
          <span className="text-[#D4AF37] font-['Inter'] font-semibold tracking-[0.2em] text-sm mb-6 uppercase" data-id="element-74">
            Guía Práctica 2026
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-['Playfair_Display'] text-[#FFF8F0] leading-[1.1] mb-6" data-id="element-75">
            ¿Tu mente <br className="hidden md:block" data-id="element-76" />
            <span className="italic text-[#D4AF37]" data-id="element-77">no para?</span>
          </h1>
          <p className="text-lg md:text-xl text-[#A8B2D1] font-['Inter'] leading-relaxed mb-10 max-w-2xl" data-id="element-78">
            Descubre cómo 2500 años de sabiduría budista pueden ayudarte a
            encontrar calma en la era del ruido digital, la ansiedad y la prisa
            constante.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 w-full sm:w-auto" data-id="element-79">
            <a href="https://templeofpages.com//cart/48626364481779:1" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'El Budismo Hoy 2026',
                content_type: 'product',
                value: 8.99,
                currency: 'USD'
              });
            }
          }} className="w-full sm:w-auto bg-[#D4AF37] text-white px-8 py-4 rounded-lg font-semibold font-['Inter'] text-lg hover:bg-[#E8C84A] transition-all shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transform hover:-translate-y-1 inline-block text-center" data-id="element-80">
              Descargar Ahora — Solo $8.99
            </a>
          </div>
          <p className="mt-6 text-sm text-[#8892B0] font-['Inter'] flex items-center gap-2" data-id="element-81">
            Acceso instantáneo · Formato PDF
          </p>
        </motion.div>

        {/* Right Content - Book Cover Image */}
        <motion.div className="lg:col-span-5 flex justify-center lg:justify-end" initial={{
        opacity: 0,
        x: 40
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-82">
          <motion.div className="relative" animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/5NXbVX3LvYCQfUhPkd41eT/portada_budismo_(1).png" alt="El Budismo Hoy: Una mirada al 2026 — Portada del libro" className="w-64 sm:w-72 md:w-80 h-auto rounded-2xl shadow-[20px_20px_60px_rgba(0,0,0,0.5),0_0_40px_rgba(212,175,55,0.15)] border border-[#D4AF37]/20" data-id="element-84" />
            {/* Subtle glow behind the book */}
            <div className="absolute -inset-4 bg-[#D4AF37]/10 rounded-3xl blur-2xl -z-10 pointer-events-none" data-id="element-85" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}